import React from "react";
import {Box} from "@mui/system";
import styles from "../Utilities/templateStyles";
import {Grid} from "@mui/material";
import useGenerateReplies from "../Utilities/hooks/useGenerateReplies";
import CircularProgress from "@mui/material/CircularProgress";
import _ from 'lodash';
import UseReplyButton from "../Utilities/UseReplyButton";
import {getCapitalizedWords} from "_helpers";

export default function CreateReplies({ handleReplies, selectedReplies, displayGenerateReplies, selectedChannel }) {
    const { replies, loading, requested } = useGenerateReplies();
    let message = '';
    let renderEmptyState = true;
    let messageObj = {
        default: 'Replies will appear once criteria fields are filled out',
        empty: 'No replies generated',
        unsupported: `${getCapitalizedWords(selectedChannel)} does not support auto-generated replies`,
        loading: <CircularProgress size={25} sx={{ color: '#003300'}}/>
    };

    if(!requested && _.isEmpty(replies)) {
        message = messageObj.default;
        renderEmptyState = true;
    }
    if(loading) {
        message = messageObj.loading
        renderEmptyState = true;
    }
    if (!loading && requested &&  _.isEmpty(replies)){
        message = messageObj.empty;
        renderEmptyState = true;
    }
    if (!loading && requested &&  !_.isEmpty(replies)){
        renderEmptyState = false;
    }

    if (displayGenerateReplies === undefined){
        message = messageObj.default;
    }

    if (displayGenerateReplies === false){
        message = messageObj.unsupported;
    }

    const RepliesContent = ({ replies }) => {
        if(renderEmptyState || !displayGenerateReplies) {
            return (
                <Box sx={styles.repliesContainerEmptyState}>
                    { message }
                </Box>
            )
        }
        return (
            <Box sx={{marginTop: '12px'}}>
                <Box component={'ul'} sx={{listStyle: 'none', m: 0, p: 0}}>
                    { replies.map((item, index, replies) =>
                        <UseReplyButton
                            key={index}
                            item={item}
                            index={index}
                            replies={replies}
                            selectedReplies={selectedReplies}
                            handleReplies={handleReplies}
                        />)
                    }
                </Box>
            </Box>
        )
    }

    return(
        <>
            <Grid item xs={12} md={6} sx={styles.repliesSection}>
                {
                    displayGenerateReplies !== false && <Box sx={styles.heading}> Replies </Box>
                }
                <RepliesContent replies={replies} />
            </Grid>
        </>
    )
}